export default __webpack_public_path__ + "static/media/splash-screen.ecd70683.JPG";